import { render, staticRenderFns } from "./WAppIcon.vue?vue&type=template&id=2a21a5ef&scoped=true"
import script from "./WAppIcon.vue?vue&type=script&lang=js"
export * from "./WAppIcon.vue?vue&type=script&lang=js"
import style0 from "./WAppIcon.vue?vue&type=style&index=0&id=2a21a5ef&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a21a5ef",
  null
  
)

export default component.exports